import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function Login({ onLoginSuccess }) {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password && !email) {
      setMessage("Veuillez renseigner votre email et code de réservation");
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://ekapi.bblconcept.com/Login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

     if (data.message === "OK") {
			localStorage.setItem('userData', JSON.stringify(data.user)); // garde la session
			onLoginSuccess(data.user);  // 🔥 Met à jour App.js immédiatement
			navigate("/");              // ✅ redirection après login
		}
	else {
		  setMessage(data.message || "Erreur lors de la connexion.");
		 // setMessageType("danger");
        //setMessage("Mot de passe ou email incorrect");
      }
    } catch (err) {
      console.error(err);
      setMessage("Erreur réseau, veuillez réessayer");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #03224C, #ADD8E6)',
      fontFamily: 'Arial, sans-serif',
      color: '#fff',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(0,0,0,0.6)',
        padding: '40px',
        borderRadius: '15px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.5)',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center'
      }}>
	  <img src="logo2.jpg" className="logoConnexion" alt="Logo"/>
	  <p></p>
        <h2 style={{ marginBottom: '30px' }}>Connexion à votre espace</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '20px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '16px'
            }}
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '20px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '16px'
            }}
          />
          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#fff',
              color: '#6B5B95',
              fontWeight: 'bold',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            {isLoading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
		<div className="auth-links">
		  <Link to="/resetpassword" className="auth-link">Mot de passe oublié ?</Link>
		  <Link to="/Register" className="auth-link">Créer un compte</Link>
		</div>


        {message && <p style={{ marginTop: '20px', color: '#FFD700' }}>{message}</p>}
      </div>
    </div>
  );
}
